import { useState } from "react";
import { useTranslation } from "react-i18next";

import { TextField } from "@mui/material";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEye, faEyeSlash, faTimes } from "@fortawesome/free-solid-svg-icons";

import { Props } from "./interfaces";
import { AdornmentContainer, IconButton } from "./styles";

const MaskedInput = ({ value, handleChange, handleClearInput, label, name, error, onBlur }: Props) => {
  const { t } = useTranslation();

  const [masked, setMasked] = useState<boolean>(true);

  return (
    <TextField
      name={name}
      value={value}
      onChange={handleChange}
      type={masked ? "password" : "text"}
      label={`${t(label)}`}
      InputProps={{
        autoComplete: "new-password",
        endAdornment: (
          <AdornmentContainer>
            {handleClearInput && (
              <IconButton
                onClick={() => handleClearInput(name)}
                visible={!!value.length}
              >
                <FontAwesomeIcon icon={faTimes} />
              </IconButton>
            )}
            <IconButton
              onMouseDown={() => setMasked(false)}
              onMouseUp={() => setMasked(true)}
              visible={!!value.length}
            >
              <FontAwesomeIcon icon={masked ? faEye : faEyeSlash} />
            </IconButton>
          </AdornmentContainer>
        ),
      }}
      helperText={error ?? ""}
      error={!!error}
      onBlur={onBlur}
    />
  );
};

export default MaskedInput;
